import {
  getBinaryBaselineScaleUrl,
  getConfigDeadlineUrl,
} from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export class ConfigService {
  static getGlobalDaysAfterTermDeadline() {
    return getRequest(getConfigDeadlineUrl());
  }

  static setGlobalDaysAfterTermDeadline(days) {
    const body = { days };
    return postRequest(getConfigDeadlineUrl(), body);
  }

  static getBinaryBaselineScale() {
    return getRequest(getBinaryBaselineScaleUrl());
  }

  static createOrUpdateBinaryBaselineScale(
    masteredLevelId,
    notMasteredLevelId
  ) {
    const body = {
      mastered_level_id: masteredLevelId,
      not_mastered_level_id: notMasteredLevelId,
    };
    return postRequest(getBinaryBaselineScaleUrl(), body);
  }
}
